import React from 'react';
export default function ComponentLoading() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: 300,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-spinner fa-spin",
    style: {
      fontSize: 36,
      color: '#5c5c5d'
    }
  }));
}